import * as React from "react";
import { useMutation, useQueryClient } from "react-query";

import { Resource } from "../Services/ResourceService";

import { UseCRUD } from "./hookTypes";
import useCreate from "./useCreate";
import useDelete from "./useDelete";
import useRead from "./useRead";
import useUpdate from "./useUpdate";

function useCRUD<T extends Resource, K extends Resource = T>({
  service,
  id,
}: UseCRUD<T>) {
  const create = useCreate({ service, id });
  const read = useRead({ service, id });
  const update = useUpdate({ service, id });
  const deleteOne = useDelete({ service, id });

  const isLoading =
    create.isCreating ||
    read.isReading ||
    update.isUpdating ||
    deleteOne.isDeleting;

  return {
    ...create,
    ...read,
    ...update,
    ...deleteOne,
    isLoading,
  };
}

export default useCRUD;
